import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type AdminStore = {
  isAdmin: boolean;
  isSuperAdmin: boolean;
  setPassword: (adminPassword: string, superAdminPassword?: string) => void;
};

const RIGHT_PASSWORD = 'CWAPISAWESOME';

export const useAdminStore = create(
  persist<AdminStore>(
    (set) => {
      return {
        isAdmin: false,
        isSuperAdmin: false,
        setPassword: (adminPassword, superAdminPassword) => {
          set({ isAdmin: RIGHT_PASSWORD === adminPassword, isSuperAdmin: RIGHT_PASSWORD === superAdminPassword });
        },
      };
    },
    {
      name: 'kajdhkjashdjkadh',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
